import * as React from 'react';
import classNames from 'classnames';
import { ButtonRegular, ButtonRegularProps } from '../Button';
import { Icon } from '../Icon';
import styles from './ArrowButton.module.scss';

export type ArrowButtonProps = ButtonRegularProps & {
	readonly className?: string;
	readonly prev?: boolean;
	readonly prevLabel?: string;
	readonly next?: boolean;
	readonly nextLabel?: string;
	readonly isVertical?: boolean;
	readonly isHiddenWhenDisabled?: boolean;
};

export const ArrowButton: React.FC<ArrowButtonProps> = ({
	className,
	prev,
	prevLabel = 'Previous',
	next,
	nextLabel = 'Next',
	isVertical,
	onClick,
	disabled,
	isHiddenWhenDisabled,
}) => {
	return (
		<ButtonRegular
			className={classNames(styles.button, className, {
				[styles.isPrev]: prev,
				[styles.isNext]: next,
				[styles.isVertical]: isVertical,
				[styles.isHidden]: disabled && isHiddenWhenDisabled,
			})}
			aria-label={prev ? prevLabel : nextLabel}
			variant={'ghost'}
			hasOnlyIcon
			onClick={onClick}
			disabled={disabled}
		>
			<Icon className={styles.icon} name={'chevronDown'} size={'md'} />
		</ButtonRegular>
	);
};
